// @flow

import { Text, View } from 'reshaped';

import { FieldSet } from './FieldSet';
import type { FormSection } from './types';

type Props = {
  section: FormSection,
};

export function Section({ section }: Props): React.MixedElement | null {
  const toRender = section.toRender || section.toRender === undefined;

  return toRender ? (
    <>
      {section.title && (
        <View paddingBlock={4}>
          <Text variant="body-2" weight="bold">
            {section.title}
          </Text>
        </View>
      )}
      <View gap={6}>
        {section.fieldSet.map(row => {
          if (row.every(field => field.toRender === false) || !row[0]) {
            return null;
          }
          return <FieldSet row={row} key={row[0].name} />;
        })}
      </View>
    </>
  ) : null;
}
